export default __webpack_public_path__ + "static/media/Amaranth-Regular.971fcc42.ttf";